import { render, staticRenderFns } from "./PPiePercentage.vue?vue&type=template&id=ef1263b2&scoped=true&"
import script from "./PPiePercentage.vue?vue&type=script&lang=ts&"
export * from "./PPiePercentage.vue?vue&type=script&lang=ts&"
import style0 from "./PPiePercentage.vue?vue&type=style&index=0&id=ef1263b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1263b2",
  null
  
)

export default component.exports